import React from 'react';
import PropTypes from 'prop-types';
import Colors from 'common/constants/colors';
import './index.scss';

export default class SwatchPicker extends React.Component {
  static propTypes = {
    colors: PropTypes.arrayOf(PropTypes.array),
    handleChange: PropTypes.func,
  };

  static defaultProps = {
    colors: [
      Colors.grayscale,
      Colors.redpanda,
      Colors.bengaltyga,
      Colors.honeybee,
      Colors.lucid,
      Colors.seagrass,
      Colors.bluefintuna,
      Colors.seaurchin,
    ].map((palette) => palette.split(', ')),
    handleChange: () => {},
  };

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    return (
      <div className={'SwatchPicker'} onClick={this.handleClick}>
        {this.props.colors.map((row, index) => (
          <div className={'SwatchPicker--row'} key={`swatchRow${index}`}>
            {row.map((color, colorIndex) => (
              <div
                className={'SwatchPicker--swatch'}
                data-color={color}
                key={`swatch${colorIndex}`}
                style={{
                  backgroundColor: color,
                }}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }

  handleClick(event) {
    const {color} = event.target.dataset;
    if (color) {
      this.props.handleChange(color);
    }
  }
}
